import { BottomOfPage } from "@/components/atoms/BottomOfPage"
import { SelectRounded } from "@/components/atoms/SelectRounded"
import { LoadingSpinner } from "@/components/molecules/LoadingSpinner"
import { useLogGetAll } from "@/lib/api/log"
import { useScannerGetAll } from "@/lib/api/scanner"
import { ComboboxItem, Table } from "@mantine/core"
import { useState } from "react"
import useInfiniteScroll from "react-infinite-scroll-hook"

export const Logs = () => {
  const [scanner, SetScanner] = useState<number | undefined>()

  const { data: scanners, isLoading: isLoadingScanners } = useScannerGetAll()
  const { data: logs, isLoading: isLoadingLogs, isFetchingNextPage, hasNextPage, fetchNextPage } = useLogGetAll({ scanner })

  const [sentryRef] = useInfiniteScroll({
    loading: isFetchingNextPage,
    hasNextPage: Boolean(hasNextPage),
    onLoadMore: fetchNextPage,
    rootMargin: "0px",
  });

  if (isLoadingScanners || isLoadingLogs) return <LoadingSpinner />

  const handleSelectScanner = (option: ComboboxItem | null) => {
    if (!option) {
      SetScanner(undefined)
      return
    }

    const id = Number(option.value)
    const scanner = scanners?.find(s => s.id === id)

    SetScanner(scanner?.id)
  }

  const rows = logs.map((log) => (
    <Table.Tr key={log.id}>
      <Table.Td>{log.scanner.name}</Table.Td>
      <Table.Td><pre>{log.content}</pre></Table.Td>
    </Table.Tr>
  ));

  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center justify-end gap-2">
        <SelectRounded
          label="Scanner"
          placeholder="Any"
          searchable
          clearable
          data={scanners?.map(s => ({ value: s.id.toString(), label: s.name }))}
          value={scanners?.find(s => s.id === scanner)?.id.toString() ?? null}
          onChange={(_, option) => handleSelectScanner(option)}
        />
      </div>
      <Table>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Scanner</Table.Th>
            <Table.Th>Message</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>{rows}</Table.Tbody>
      </Table>
      <BottomOfPage ref={sentryRef} showLoading={isFetchingNextPage} hasNextPage={hasNextPage} />
    </div>
  )
}
